export const parameterize = (str: string): string => {
  return str.toLowerCase().replace(/_|\s/g, "-")
}
